import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import LogoutIcon from "@mui/icons-material/Logout";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Snackbar, Alert } from "@mui/material";

import "./Navbar.css";

const navConfig = {
    guest: [
        { label: "الرئيسية", path: "/" },
        { label: "نبذة عن التطبيق", path: "/about" },
        { label: "المزايا", path: "/features" },
        { label: "انضم إلينا", path: "/join" },
        { label: "تواصل معنا", path: "/contact" },
    ],
    customer: [
        { label: "مواعيدي", path: "/customer/appointments" },
        { label: "ملفي الشخصي", path: "/customer/profile" },
    ],
    admin: [
        { label: "الرئيسية", path: "/admin/dashboard" },
        { label: "ادارة الفروع", path: "/admin/manage-branches" },
        { label: "ادارة الموظفين", path: "/admin/manage-employees" },
        { label: "ادارة الخدمات", path: "/admin/manage-services" },
        { label: "الاعدادات", path: "/admin/manage-settings" },
    ],
    branchManager: [
        { label: "لوحة الفروع", path: "/branch/dashboard" },
        { label: "الحجوزات", path: "/branch/reservations" },
    ],
    employee: [{ label: "الرئيسية", path: "/employee/dashboard" }],
};

export default function Navbar() {
    const { instLogo, user, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarContent, setSnackbarContent] = useState({ message: "", type: "success" });

    const role = user?.role ?? "guest";
    const navItems = navConfig[role] || navConfig.guest;

    const handleGenerateLink = async () => {
        try {
            const inst = JSON.parse(localStorage.getItem("institution"));
            const instId = inst?.id;
            if (!instId) throw new Error("حدث خطأ اثناء نسخ الرابط");

            const link = `https://www.wnvr.me/institution/${instId}`;
            await navigator.clipboard.writeText(link);

            setSnackbarContent({ message: "تم نسخ الرابط إلى الحافظة", type: "success" });
        } catch (err) {
            setSnackbarContent({ message: err.message || "حدث خطأ أثناء نسخ الرابط", type: "error" });
        } finally {
            setSnackbarOpen(true);
        }
    };

    return (
        <header className="navbar">
            <div className="navbar-container">
                <div className="navbar-left">
                    <div className="logo">WNVR</div>
                    {instLogo && (
                        <>
                            <div className="btn-divider" />
                            <div className="logo">
                                <img
                                    src={instLogo}
                                    alt="Institution Logo"
                                    style={{ borderRadius:6, height: "100%", maxHeight: "40px", width: "auto", objectFit: "contain" }}
                                />
                            </div>
                        </>
                    )}
                </div>

                <button className="hamburger" onClick={() => setOpen((p) => !p)} aria-label="Toggle menu">
                    ☰
                </button>

                <nav className={`nav-menu ${open ? "open" : ""}`}>
                    {!user && (
                        <div className="auth-buttons-left">
                            <Link to="/login" className="btn outline">تسجيل الدخول</Link>
                            <Link to="/signup" className="btn filled">إنشاء حساب</Link>
                            <div className="btn-divider" />
                        </div>
                    )}

                    {/* ✅ زر نسخ الرابط للمسؤول فقط */}
                    {user && user.role === "admin" && (
                        <div className="auth-buttons-left">
                            <button onClick={handleGenerateLink} className="btn outline">
                                شارك رابط المؤسسة
                            </button>
                            <div className="btn-divider" />
                        </div>
                    )}

                    <ul className="nav-items">
                        {navItems.map((item) => (
                            <li key={item.label} className={`nav-item ${location.pathname === item.path ? "active" : ""}`}>
                                <Link to={item.path}>{item.label}</Link>
                            </li>
                        ))}
                    </ul>

                    {user && (
                        <button
                            className="logout-button"
                            onClick={() => {
                                logout();
                                navigate("/login");
                            }}
                            title="تسجيل الخروج"
                        >
                            <LogoutIcon sx={{ color: 'red', fontSize: "20px" }} />
                        </button>
                    )}
                </nav>
            </div>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity={snackbarContent.type}
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {snackbarContent.message}
                </Alert>
            </Snackbar>
        </header>
    );
}
